import { Component, Inject, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { RxjsService, CrudService, ModulesBasedApiSuffix, IApplicationResponse, ResponseMessageTypes, SnackbarService, ConfirmDialogModel, PrimengConfirmDialogPopupComponent, setRequiredValidator, OtherService, clearFormControlValidators, CustomDirectiveConfig, findInvalidControls, UserService, calculateBOMPrice, toRoundOffWithMathRound, prepareRequiredHttpParams, calculatePRCallPrice, calculateVatTotalBOMPrice } from '@app/shared';
import { PrCallStockItemArray, PrCallStockItemModel } from '@modules/customer/models/bill-of-material.model';
import { TechnicalMgntModuleApiSuffixModels } from '@modules/technical-management/shared/enum.ts/technical.enum';
import { DialogService } from 'primeng/api';
import { debounceTime, distinctUntilChanged, switchMap } from 'rxjs/operators';

@Component({
  selector: 'app-pr-call-doa-request-dialog',
  templateUrl: './pr-call-doa-request-dialog.component.html',
  styles: [`::ng-deep .escalate-text, .label-text {
    font-size: 14px;
  }`]
})
export class PrCallDoaRequestDialogComponent implements OnInit {

  prCallRequestForm: FormGroup;
  stockCodeErrorMessage: string;
  showStockCodeError: boolean;
  isStockError: boolean;
  filteredPRStockCodes: any = [];
  isLoading: boolean;
  isSubmitted: boolean;
  numberConfig = new CustomDirectiveConfig({ isANumberOnly: true });
  deleteStockCodeDialog: any;
  isFirstStockNumDel: boolean;
  prCallResponse: any = {};
  isEscalateSubmit: boolean = false;

  constructor(private rxjsService: RxjsService, @Inject(MAT_DIALOG_DATA) public data: any, private formBuilder: FormBuilder, private userService: UserService,
    public ref: MatDialogRef<PrCallDoaRequestDialogComponent>, private crudService: CrudService, private snackbarService: SnackbarService,
    public dialogService: DialogService, private otherService: OtherService,) {
    this.rxjsService.setDialogOpenProperty(true);
  }

  ngOnInit(): void {
    this.initForm();
    this.onLoadValue();
  }

  initForm(prCallStockItemModel?: PrCallStockItemModel) {
    let PrCallReqModel = new PrCallStockItemModel(prCallStockItemModel);
    this.prCallRequestForm = this.formBuilder.group({});
    let PrStockItemDetails = this.formBuilder.array([]);
    Object.keys(PrCallReqModel).forEach((key) => {
      if (typeof PrCallReqModel[key] !== 'object') {
        this.prCallRequestForm.addControl(key, new FormControl(PrCallReqModel[key]));
      } else {
        if (key == 'stockItems') {
          this.prCallRequestForm.addControl(key, PrStockItemDetails);
        }
      }
    });
    this.prCallRequestForm = setRequiredValidator(this.prCallRequestForm, ['comments']);
    this.onFormValueChanges();
  }

  get PrStockItemsFormArray(): FormArray {
    if (this.prCallRequestForm !== undefined) {
      return (<FormArray>this.prCallRequestForm.get('stockItems'));
    }
  }

  onFormValueChanges() {
    this.prCallRequestForm.get('equipment').valueChanges.pipe(debounceTime(100), distinctUntilChanged(),
      switchMap(searchText => {
        searchText = !searchText ? searchText : searchText?.trim();

        if (searchText != null) {
          if (!searchText) {
            if (searchText === '') {
              this.stockCodeErrorMessage = '';
              this.showStockCodeError = false;
              this.isStockError = false;
            }
            else {
              this.stockCodeErrorMessage = 'Stock code is not available in the system';
              this.showStockCodeError = true;
              this.isStockError = true;
            }
            this.rxjsService.setGlobalLoaderProperty(false);
            return this.filteredPRStockCodes = [];
          } else {
            let searchStockObject = Object.assign({},
              searchText == null ? null : { ItemCode: searchText, CallInitiationId: this.data?.billOfMaterialModel?.callInitiationId },
              this.data?.billOfMaterialModel['districtId'] == null ? null : { DistrictId: this.data?.billOfMaterialModel['districtId'] },
              this.data?.billOfMaterialModel['warehouseId'] == null ? null : { WarehouseId: this.data?.billOfMaterialModel['warehouseId'] },
              this.data?.billOfMaterialModel['itemPricingConfigId'] == null ? null : { itemPricingConfigId: this.data?.billOfMaterialModel['itemPricingConfigId'] },
              this.data?.billOfMaterialModel['technicianId'] == null ? null : { TechnicianId: this.data?.billOfMaterialModel['technicianId'] });
            if (this.data?.stockType?.toLowerCase() != 'm') {
              if (this.data?.billOfMaterialModel['technicianId']) {
                this.stockCodeErrorMessage = '';
                this.showStockCodeError = false;
                this.isStockError = false;
                return this.crudService.get(
                  ModulesBasedApiSuffix.TECHNICIAN,
                  TechnicalMgntModuleApiSuffixModels.BILL_OF_MATERIAL_SEARCH_STOCK_DETAILS_TECHNICIAN, null, true,
                  prepareRequiredHttpParams(searchStockObject))
              } else {
                this.stockCodeErrorMessage = 'Stock code is not available against technician stock location';
                this.showStockCodeError = true;
                this.isStockError = true;
                this.rxjsService.setGlobalLoaderProperty(false);
                return this.filteredPRStockCodes = [];
              }
            }
          }
        }
      })).subscribe((response: IApplicationResponse) => {
        if (response.isSuccess && response.resources.length > 0) {
          this.filteredPRStockCodes = response.resources;
          this.stockCodeErrorMessage = '';
          this.showStockCodeError = false;
          this.isStockError = false;
        } else {
          this.filteredPRStockCodes = [];
          this.stockCodeErrorMessage = 'Stock code is not available in the system';
          this.showStockCodeError = true;
          this.isStockError = true;
        }
        this.rxjsService.setGlobalLoaderProperty(false);
      });
  }

  onLoadValue() {
    console.log(this.data);
    this.openPrCallDialog();
  }

  openPrCallDialog() {
    if (this.data?.billOfMaterialModel?.serviceCallRequestId == null) {
      this.isEscalateSubmit = false;
    }
    else {
      this.isEscalateSubmit = true;
    }
    this.PrStockItemsFormArray.clear();
    const unitPrice = this.otherService.transformCurrToNum(this.data?.newData?.stockUnitPriceExVat);
    const result = calculateBOMPrice({
      qty: this.data?.newData?.stockQty,
      price: unitPrice,
      taxPercent: this.data?.standardTax, roundFn: toRoundOffWithMathRound,
      singlePrice: true
    });
    const PrStockItem = {
      itemId: this.data?.newData?.itemId,
      stockCode: this.data?.newData?.stockCode,
      stockDesc: this.data?.newData?.stockDesc,
      stockQty: this.data?.newData?.stockQty,
      stockUnitPriceExVat: this.otherService.transformDecimal(this.data?.newData?.stockUnitPriceExVat),
      stockUnitPriceIncVat: this.otherService.transformDecimal(result?.unitPriceIncVat),
      stockSubTotalExVat: this.otherService.transformDecimal(result?.subTotal),
      stockSubTotalIncVat: this.otherService.transformDecimal(result?.totalAmount),
      itemPricingConfigId: this.data?.newData?.itemPricingConfigId
    };
    this.initFormArray(PrStockItem);
    this.data?.resources?.equipments?.forEach((element: any) => {
      if (element) {
        const result = calculatePRCallPrice({
          qty: element?.qtyRequired,
          exclVAT: element?.exclVAT,
          taxPercent: this.data?.standardTax, roundFn: toRoundOffWithMathRound,
        });
        const PrStockItem = {
          itemId: element.itemId,
          stockCode: element.itemCode,
          stockDesc: element.itemName,
          stockQty: element.qtyRequired,
          stockUnitPriceExVat: this.otherService.transformDecimal(result?.priceExVat),
          stockUnitPriceIncVat: this.otherService.transformDecimal(result?.totalAmount),
          stockSubTotalExVat: this.otherService.transformDecimal(element.exclVAT),
          stockSubTotalIncVat: this.otherService.transformDecimal(element.inclVAT),
          itemPricingConfigId: this.data?.newData?.itemPricingConfigId
        };
        this.initFormArray(PrStockItem);
      }
    });
  }

  initFormArray(nkaDoaRequestItemArray?: PrCallStockItemArray) {
    let nkaDoaRequestModel: any = new PrCallStockItemArray(nkaDoaRequestItemArray);
    let prCallRequestFormArray = this.formBuilder.group({});
    Object.keys(nkaDoaRequestModel).forEach((key) => {
      prCallRequestFormArray.addControl(key, new FormControl({ value: nkaDoaRequestModel[key], disabled: key == 'stockQty' ? false : true }));
    });
    prCallRequestFormArray = setRequiredValidator(prCallRequestFormArray, ['stockQty', 'itemId', 'stockCode', 'stockDesc', 'stockUnitPriceExVat', 'stockUnitPriceIncVat', 'stockSubTotalExVat', 'stockSubTotalIncVat', 'itemPricingConfigId']);
    prCallRequestFormArray.get('stockQty')?.setValidators([Validators.required, Validators.min(1), Validators.maxLength(5)]);
    prCallRequestFormArray.get('stockQty')?.valueChanges.subscribe((qty) => {
      const unitPrice = this.otherService.transformCurrToNum(prCallRequestFormArray.get('stockUnitPriceExVat')?.value);
      let subTotal = 0;
      let totalAmount = 0;
      if (qty) {
        const result = calculateBOMPrice({
          qty: qty,
          price: unitPrice,
          taxPercent: this.data?.standardTax, roundFn: toRoundOffWithMathRound
        });
        subTotal = result?.subTotal;
        totalAmount = result?.totalAmount;
      }
      prCallRequestFormArray.controls['stockSubTotalExVat'].patchValue(this.otherService.transformDecimal(subTotal));
      prCallRequestFormArray.controls['stockSubTotalIncVat'].patchValue(this.otherService.transformDecimal(totalAmount));
      this.calculateTotal();
    })
    this.PrStockItemsFormArray.push(prCallRequestFormArray);
    this.calculateTotal();
  }

  calculateTotal() {
    this.prCallRequestForm?.get('totalStockItems').setValue('R 0.00');
    let total = 0;
    this.PrStockItemsFormArray.getRawValue()?.forEach((item) => {
      total += +this.otherService.transformCurrToNum(item.stockSubTotalIncVat);
      this.prCallRequestForm?.get('totalStockItems').setValue(total ? this.otherService.transformDecimal(+total) : '');
    })
  }

  changeEscalate() {
    // if (!this.data?.billOfMaterialModel?.billOfMaterialId) {
    //   return this.snackbarService.openSnackbar("Please save the bill of materials first");
    // }
    this.ref.close(this.data);
  }

  clearFormArray = (formArray: FormArray) => {
    while (formArray.length !== 0) {
      formArray.removeAt(0);
    }
  };

  addEquipmentLabor() {
    if (!this.prCallRequestForm.get('equipment').value) {
      this.prCallRequestForm = setRequiredValidator(this.prCallRequestForm, ["equipment"]);
      this.prCallRequestForm.get('equipment').markAsTouched();
      return;
    }
    this.prCallRequestForm = setRequiredValidator(this.prCallRequestForm, ['equipment']);
    let addEquipmentLaborVal = this.prCallRequestForm.get('equipment').value;
    if (this.prCallRequestForm.get('equipment').value) {
      let item = this.filteredPRStockCodes.find(x => x?.id == addEquipmentLaborVal?.id);
      let prStockItemsArr = this.PrStockItemsFormArray.getRawValue();
      let filterItem = prStockItemsArr.filter(x => x?.itemId == addEquipmentLaborVal?.id);
      if (filterItem && filterItem.length > 0) {
        this.snackbarService.openSnackbar('Stock Code is already added.')
        return;
      }
      const result = calculateVatTotalBOMPrice({
        roundedSubTotal: item?.costPrice,
        taxPercent: this.data?.standardTax, roundFn: toRoundOffWithMathRound
      });
      const PrStockItem = {
        itemId: item.id,
        stockCode: item.itemCode,
        stockDesc: item.displayName,
        stockQty: '',
        stockUnitPriceExVat: item.costPrice ? this.otherService.transformDecimal(item.costPrice) : 'R 0.00',
        stockUnitPriceIncVat: this.otherService.transformDecimal(result?.totalAmount),
        stockSubTotalExVat: 'R 0.00',
        stockSubTotalIncVat: 'R 0.00',
        itemPricingConfigId: item.itemPricingConfigId
      }
      this.initFormArray(PrStockItem);
      this.prCallRequestForm.get('equipment')?.reset('', { emitEvent: false });
      this.filteredPRStockCodes = [];
      this.onFormValueChanges();
    }
  }

  deleteStockNumbers(index) {
    const message = `Are you sure you want to delete this?`;
    const dialogData = new ConfirmDialogModel("Confirm Action", message);
    this.userService.openedPrimeDialog.push(this.deleteStockCodeDialog);
    this.deleteStockCodeDialog = this.dialogService.open(PrimengConfirmDialogPopupComponent, {
      showHeader: false,
      width: "450px",
      data: { ...dialogData, isClose: true },
      baseZIndex: 6000,
    });
    this.deleteStockCodeDialog.onClose.subscribe(dialogResult => {
      this.userService.openedPrimeDialog = [];
      if (!dialogResult) return;
      if (index == 0) {
        this.isFirstStockNumDel = true;
      } else {
        this.isFirstStockNumDel = false;
      }
      this.PrStockItemsFormArray.removeAt(index);
      this.calculateTotal();
    });
  }

  displayFn(val) {
    if (val) { return val?.itemCode ? val?.itemCode : val; } else { return val }
  }

  btnCloseClick() {
    this.rxjsService.setDialogOpenProperty(false);
    this.ref.close(false);
  }

  onSubmitDialog() {
    this.prCallRequestForm = clearFormControlValidators(this.prCallRequestForm, ['equipment']);
    if (findInvalidControls(this.prCallRequestForm.controls)) {
      this.prCallRequestForm.markAllAsTouched();
      return;
    }
    if (this.prCallRequestForm.value.stockItems && this.prCallRequestForm.value.stockItems?.length == 0) {
      return this.snackbarService.openSnackbar('Atleast one Equipment and Additional Labor must be added', ResponseMessageTypes.ERROR);
    }
    if (this.data?.billOfMaterialModel.isPRCall) {
      this.crudService.create(
        ModulesBasedApiSuffix.TECHNICIAN,
        TechnicalMgntModuleApiSuffixModels.PR_CALL,
        this.getValue()
      ).subscribe((response: IApplicationResponse) => {
        if (response.isSuccess && response?.statusCode == 200) {
          this.ref.close(response.resources);
          // this.alertDialog = true
          // this.alertMsg = response.resources
          this.rxjsService.setDialogOpenProperty(false);
        }
      });
    }
    else {
      this.crudService.create(
        ModulesBasedApiSuffix.TECHNICIAN,
        TechnicalMgntModuleApiSuffixModels.SAVE_OFFER,
        this.getValue()
      ).subscribe((response: IApplicationResponse) => {
        if (response.isSuccess && response?.statusCode == 200) {
          this.ref.close(response.resources);
        }
        this.rxjsService.setDialogOpenProperty(false);
      });

    }
  }

  getValue() {
    let requestBody: any = {
      serviceCallRequestId: (this.data?.billOfMaterialModel && this.data?.billOfMaterialModel.serviceCallRequestId) ? this.data?.billOfMaterialModel.serviceCallRequestId : null,
      callInitiationId: this.data?.billOfMaterialModel?.callInitiationId,
      motivation: this.prCallRequestForm.get('comments')?.value,
      createdUserId: this.data?.userId,
      isAddionalApproval: true,
      items: []
    }
    this.PrStockItemsFormArray?.getRawValue()?.forEach((el: any) => {
      if (el) {
        requestBody.items.push({
          itemId: el.itemId,
          exclVAT: el.stockUnitPriceExVat?.toString() ? this.otherService.transformCurrToNum(el?.stockUnitPriceExVat) : null,
          inclVAT: el.stockUnitPriceIncVat?.toString() ? this.otherService.transformCurrToNum(el?.stockUnitPriceIncVat) : null,
          qtyRequired: el.stockQty,
          itemPricingConfigId: el.itemPricingConfigId ? el.itemPricingConfigId : null
        })
      }
    })
    return requestBody;
  }

}
